import * as React from 'react';
import {Layout} from "./Layout";

declare const require: any;
const $: any = require('jquery');
window['$'] = $;
window['jQuery'] = $;

interface TokenizeProps {
    token: string;
}

interface TokenizeState {
    granted: boolean;
}

export class Restricted extends React.Component<TokenizeProps, TokenizeState> {
    constructor(props) {
        super(props);
        this.state = {granted: false};
    }
    
    private validateToken(e) {
        $.getJSON('/reg/dashboard?token=' + e.target.value, (granted) => {
            this.setState({granted});
        })
    }
    
    public render() {
        return (
            <Layout>
                {this.state.granted
                    ? this.props.children
                    : <div className="token"><input autoFocus={true} placeholder="Введите код доступа" type="text" onChange={e => this.validateToken(e)} /></div>
                }
            </Layout>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/layout/Restricted.tsx
 **/